import { useUserContext } from "../../../Hooks/useUserContext";
import { PaperActions } from "../../../Shared/PaperActions";
import { AuthLoadingScreen } from "../../../Shared/AuthLoadingScreen";
import React from "react";
import {
	Button
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import CloneIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import HistoryIcon from "@material-ui/icons/History";

export function RecipeViewActions(props) {
	const user = useUserContext(props.config);

	// While auth is being checked, don't render actionable buttons
	if (!user.isInitialized) {
		return <AuthLoadingScreen />;
	}

	return (
		<PaperActions
			className="no-print rb-recipe-actions"
			left={
				<React.Fragment>
					<Button
						variant="contained"
						color="primary"
						disabled={!user.isInitialized || !user.canEditRecipe}
						onClick={props.editRecipe}>
						<EditIcon style={{ marginRight: 10 }} />Edit
					</Button>
					<Button
						variant="contained"
						color="primary"
						disabled={!user.isInitialized || !user.canEditRecipe}
						onClick={props.cloneRecipe}>
						<CloneIcon style={{ marginRight: 10 }} />Clone
					</Button>
					<Button
						style={{ marginRight: 20 }}
						variant="contained"
						onClick={props.viewHistory}>
						<HistoryIcon style={{ marginRight: 10 }} />History
					</Button>
					<Button
						variant="contained"
						disabled={!user.isInitialized || !user.canEditRecipe}
						onClick={props.deleteRecipe}>
						<DeleteIcon style={{ marginRight: 10 }} /> Delete
					</Button>
				</React.Fragment>
			} />
	);
}
